<div class="ui-procedures-list">
    <div class="ui-procedures-list-table" *ngIf="proceduresInitStatus">
        <h3 class="ui-title">Últimas gestiones</h3>
            
        <div class="ui-bar-filters">
            <div class="el-left-filters">
                <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterStatus">Estado<i *ngIf="filters.status != ''">: {{filters.status}}</i> <mat-icon>expand_more</mat-icon></button>

                <mat-menu #filterStatus="matMenu">
                    <button mat-menu-item (click)="onFilterSelect('status', '')">Todo</button>
                    <button mat-menu-item (click)="onFilterSelect('status', item.name)" *ngFor="let item of filterProceduresStatus; last as last">{{item.name}}</button>
                </mat-menu>
                
                <!--<mat-menu #filterStatus="matMenu">
                    <button mat-menu-item (click)="onFilterSelect('status', '')">Todo</button>
                    <button mat-menu-item (click)="onFilterSelect('status', 'Iniciado')">Iniciado</button>
                    <button mat-menu-item (click)="onFilterSelect('status', 'Pendiente')">Pendiente</button>
                    <button mat-menu-item (click)="onFilterSelect('status', 'Ingresado')">Ingresado</button>
                    <button mat-menu-item (click)="onFilterSelect('status', 'Finalizado')">Finalizado</button>
                </mat-menu>-->
                
                <mat-form-field class="date-multiple" >
                    <mat-label>Fecha de inicio</mat-label>
                    <mat-date-range-input [rangePicker]="filterDateStart" >
                        <input matStartDate placeholder="Desde" (focus)="filterDateStart.open()" [(ngModel)]="filters.dateStart.start">
                        <input matEndDate placeholder="Hasta" (focus)="filterDateStart.open()" [(ngModel)]="filters.dateStart.end" (dateChange)="onFilterSelect('dateStart')">
                    </mat-date-range-input>
                    <button matSuffix mat-flat-button (click)="onFilterSelect('dateStart', '')" *ngIf="filters.dateStart.end != '' && filters.dateStart.end != null"><mat-icon>close</mat-icon></button>
                    <mat-date-range-picker #filterDateStart></mat-date-range-picker>
                </mat-form-field>
                
                <mat-form-field class="date-multiple">
                    <mat-label>Fecha de finalización</mat-label>
                    <mat-date-range-input [rangePicker]="filterDateEnd">
                        <input matStartDate placeholder="Desde" (focus)="filterDateEnd.open()" [(ngModel)]="filters.dateEnd.start">
                        <input matEndDate placeholder="Hasta" (focus)="filterDateEnd.open()" [(ngModel)]="filters.dateEnd.end" (dateChange)="onFilterSelect('dateEnd')">
                    </mat-date-range-input>
                    <button matSuffix mat-flat-button (click)="onFilterSelect('dateEnd', '')" *ngIf="filters.dateEnd.end != '' && filters.dateEnd.end != null"><mat-icon>close</mat-icon></button>
                    <mat-date-range-picker #filterDateEnd></mat-date-range-picker>
                </mat-form-field>
            </div>

            <div class="el-right-filters">
                <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterExport">Exportar listado <mat-icon>expand_more</mat-icon></button>

                <mat-menu #filterExport="matMenu">
                    <button mat-menu-item (click)="onExport('xls')">Microsoft Excel (xlsx)</button>
                    <button mat-menu-item (click)="onExport('cvs')">CVS separado por coma (cvs)</button>
                    <button mat-menu-item (click)="onExport('json')">Archivo JSON (json)</button>
                </mat-menu>
            </div>
        </div>
        
        <div class="ui-procedures-list-table-content ui-shadow">
            <div class="ui-spinner-container" *ngIf="proceduresUpdating">
                <mat-spinner class="ui-spinner" [diameter]="25"></mat-spinner>
            </div>
            
            <div class="procedure" *ngIf="procedures.length <= 0"><div class="procedure-empty">No existen gestiones para mostrar</div></div>
            
            <div class="procedure" *ngFor="let procedure of procedures; last as last" (click)="onViewDetail(procedure)">
                <div class="procedure-indicator">
                    <mat-icon class="pending" *ngIf="procedure.status == 'Iniciado' || procedure.status == 'Pendiente' || procedure.status == 'Ingresado'">query_builder</mat-icon>
                    <mat-icon class="finish" *ngIf="procedure.status == 'Finalizado'">lens</mat-icon>
                </div>

                <div class="procedure-data">
                    <span class="procedure-number">{{procedure.id}}</span>
                    <span class="procedure-message">{{procedure.detail}}</span>
                </div>

                <div class="procedure-details">
                    <span class="procedure-status">{{procedure.status}}</span>
                    <span class="procedure-date" *ngIf="procedure.status == 'Iniciado' || procedure.status == 'Pendiente' || procedure.status == 'Ingresado'">{{procedure.dateStart | date:'dd/MM/yyyy'}}</span>
                    <span class="procedure-date" *ngIf="procedure.status == 'Finalizado'">{{procedure.dateEnd | date:'dd/MM/yyyy'}}</span>
                </div>
            </div>

            <mat-paginator *ngIf="procedures.length > 0" [length]="proceduresTotal" [pageSize]="proceduresPageSize" [pageSizeOptions]="[5, 10, 25, 50]" (page)="onPaginationChange($event)"></mat-paginator>
        </div>
    </div>

    <ui-screen-loader *ngIf="!proceduresInitStatus"></ui-screen-loader>
</div>